import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'contexts/AuthContext';
import './PumpsMainView.scss';
import './UserFilters.scss';

export default function UserFilters({ searchTerm, onSearchChange, selectedRole, onRoleChange }) {
  const { t } = useTranslation();
  const { userRole } = useAuthContext();

  const roleOptions = useMemo(() => {
    const ur = Number(userRole);
    // First chip = everyone the API returns for this viewer; always labeled "All users"
    const all = { id: null, labelKey: 'users_filter_all' };
    const mk = (id) => ({ id, labelKey: `user_role_display_${id}` });
    if (ur === 4) {
      return [all, mk(4), mk(5)];
    }
    if (ur === 5) {
      return [all, mk(5)];
    }
    if (ur === 3) {
      return [all, mk(3)];
    }
    const ids = ur === 2 ? [2, 3, 4, 5] : [1, 2, 3, 4, 5];
    return [all, ...ids.map(mk)];
  }, [userRole]);

  return (
    <div className="dashboard-toolbar d-flex align-items-center flex-nowrap justify-content-between gap-2 users-filters-toolbar">
      <div className="filter-roles users-filters-meta" role="group">
        {roleOptions.map((role) => (
          <button
            type="button"
            key={role.id ?? 'all'}
            className={`role-chip ${selectedRole === role.id ? 'active' : ''}`}
            onClick={() => onRoleChange(role.id)}
          >
            {t(role.labelKey)}
          </button>
        ))}
      </div>

      <div className="pump-search-wrapper users-filters-search toolbar-search-end">
        <i className="fas fa-search pump-search-icon" />
        <input
          type="text"
          className="pump-search-input"
          placeholder={t('users_filter_search_ph')}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        {searchTerm && (
          <button
            type="button"
            className="pump-search-clear"
            onClick={() => onSearchChange('')}
            aria-label={t('users_filter_clear_aria')}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
}
